<app-hero [title]="'Jobdetails'"></app-hero>
<section id="alt-services" class="alt-services section">
    <div class="container">
      <div class="row justify-content-around gy-4">
        <div class="col-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
            <h3>{{jobDetails.title}}</h3>
    
            <p data-aos="fade-up" data-aos-delay="300">
              {{jobDetails.text}}
            </p>
            <br>

            <p data-aos="fade-up" data-aos-delay="400">
                {{jobDetails.additionalInfo}}
            </p>

             <button *ngIf="jobDetails" 
                        (click)="navigateToApplicationComponent(jobDetails.id)" 
                        class="btn btn-primary btn-sm fw-bold mt-3" style="width: 100px;">
                  Apply Now
                </button>
    
        </div>
        <div class="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <img [src]="jobDetails.image" alt="Our Services">
        </div>
      </div>
    </div>
</section>


      <!-- Faq Section -->
<section id="faq" class="faq section">
    <div class="container">
  
      <div class="row gy-4">
        <div data-aos="fade-up" data-aos-delay="200">
          <div class="faq-container">
            <div class="faq-item" [ngClass]="{'faq-active':index==0}" *ngFor="let faq of jobDetails.faqs;let index = index">
                <h3><span class="num">{{index+1}}.</span> <span>{{faq.question}}</span></h3>
                <div class="faq-content">
                  <p>{{faq.answer}}</p>
                </div>
                <i class="faq-toggle bi bi-chevron-right"></i>
            </div><!-- End Faq item-->
          </div>

        </div>
      </div>

    </div>
</section><!-- /Faq Section -->